import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MaterialModule } from '../../../shared/material.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../../shared/shared.module';
import { MvdNowClaimAccountModalService } from '../services/mvdnow-claim-account-modal.service';
import { MvdnowClaimAccountModalComponent } from './components/mvdnow-claim-account-modal/mvdnow-claim-account-modal.component';

@NgModule({
    declarations: [
        MvdnowClaimAccountModalComponent
    ],
    imports: [
        SharedModule,
        SharedPipesModule,
        TableModule,
        InputMaskModule,
        ToastModule,
        CommonModule,
        MaterialModule,
        MatDialogModule
    ],
    providers: [
        MvdNowClaimAccountModalService
    ],
    exports: [
        MvdnowClaimAccountModalComponent
    ]
})
export class MvdnowClaimAccountSharedModule { }
